import React, { FC, ReactElement, useEffect, useRef } from 'react'

import { EuiFormRow } from '@elastic/eui'

export interface ConfigHeightEuiFormRowProps {
  height: string
  fullWidth?: boolean
  label?: string
  children: ReactElement
}

const ConfigHeightEuiFormRow: FC<ConfigHeightEuiFormRowProps> = ({ height, children, ...props }) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) {
      return
    }

    ;(ref.current.getElementsByClassName('euiFormRow__labelWrapper')[0] as HTMLDivElement).style.height = 'auto'
    ;(ref.current.getElementsByClassName('euiFormRow__fieldWrapper')[0] as HTMLDivElement).style.height = '100%'
  }, [ref])

  return (
    <div ref={ref} style={{ height: height }}>
      <EuiFormRow {...props} style={{ height: '100%' }}>
        {children}
      </EuiFormRow>
    </div>
  )
}

export default ConfigHeightEuiFormRow
